"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoctorCreateAdminDto = void 0;
const misc_1 = require("../../../misc");
const user_1 = require("../user");
class DoctorCreateAdminDto extends (0, misc_1.generateCreateDto)(user_1.User, ['doctorProfile', 'gender', 'mobile', 'name', 'type']) {
}
exports.DoctorCreateAdminDto = DoctorCreateAdminDto;
